import { render } from "./MenuAccordion.vue?vue&type=template&id=b5677bae&scoped=true"
import script from "./MenuAccordion.vue?vue&type=script&lang=js"
export * from "./MenuAccordion.vue?vue&type=script&lang=js"

import "./MenuAccordion.vue?vue&type=style&index=0&id=b5677bae&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5677bae"]])

export default __exports__